export type RouteScrollContainer = {
  containerId: string;
  element: HTMLElement;
};

const routeScrollRegistry = new Map<string, Set<HTMLElement>>();

export const registerRouteScrollContainer = (containerId: string, element: HTMLElement): void => {
  const existing = routeScrollRegistry.get(containerId);
  if (existing) {
    existing.add(element);
    return;
  }

  routeScrollRegistry.set(containerId, new Set([element]));
};

export const unregisterRouteScrollContainer = (containerId: string, element: HTMLElement): void => {
  const existing = routeScrollRegistry.get(containerId);
  if (!existing) {
    return;
  }

  existing.delete(element);
  if (existing.size === 0) {
    routeScrollRegistry.delete(containerId);
  }
};

export const getRegisteredRouteScrollContainers = (
  root: HTMLElement | null
): RouteScrollContainer[] => {
  if (!root) {
    return [];
  }

  const containers: RouteScrollContainer[] = [];
  const emptyContainerIds: string[] = [];

  routeScrollRegistry.forEach((elements, containerId) => {
    const disconnectedElements: HTMLElement[] = [];

    elements.forEach((element) => {
      if (!element.isConnected) {
        disconnectedElements.push(element);
        return;
      }

      if (root.contains(element)) {
        containers.push({ containerId, element });
      }
    });

    disconnectedElements.forEach((element) => {
      elements.delete(element);
    });

    if (elements.size === 0) {
      emptyContainerIds.push(containerId);
    }
  });

  emptyContainerIds.forEach((containerId) => {
    routeScrollRegistry.delete(containerId);
  });

  return containers;
};
